import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Thesis from "@/pages/Thesis";
import Runtime from "@/pages/Runtime";
import Proof from "@/pages/Proof";
import Architecture from "@/pages/Architecture";
import Agents from "@/pages/Agents";
import Workflow from "@/pages/Workflow";
import Economy from "@/pages/Economy";
import ArcPage from "@/pages/ArcPage";
import UseCases from "@/pages/UseCases";
import TerminalPage from "@/pages/TerminalPage";
import Docs from "@/pages/Docs";
import Sources from "@/pages/Sources";
import Token from "@/pages/Token";
import Launch from "@/pages/Launch";
import NotFound from "@/pages/NotFound";

const ScrollManager = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const useLenis = () => {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 0.95 });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);
};

const Shell = () => {
    useLenis();
    const location = useLocation();
    return (
        <div className="min-h-screen bg-[#05070B] font-display text-[#F5F9FF]">
            <div className="noise-overlay" aria-hidden="true" />
            <Navbar />
            <ScrollManager />
            <main key={location.pathname}>
                <Routes location={location}>
                    <Route path="/" element={<Home />} />
                    <Route path="/thesis" element={<Thesis />} />
                    <Route path="/runtime" element={<Runtime />} />
                    <Route path="/proof" element={<Proof />} />
                    <Route path="/architecture" element={<Architecture />} />
                    <Route path="/agents" element={<Agents />} />
                    <Route path="/workflow" element={<Workflow />} />
                    <Route path="/economy" element={<Economy />} />
                    <Route path="/arc" element={<ArcPage />} />
                    <Route path="/use-cases" element={<UseCases />} />
                    <Route path="/terminal" element={<TerminalPage />} />
                    <Route path="/docs" element={<Docs />} />
                    <Route path="/sources" element={<Sources />} />
                    <Route path="/token" element={<Token />} />
                    <Route path="/launch" element={<Launch />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </main>
            <Footer />
        </div>
    );
};

function App() {
    return (
        <HelmetProvider>
            <BrowserRouter>
                <Shell />
            </BrowserRouter>
        </HelmetProvider>
    );
}

export default App;
